<app-lex-xi-side-panel
  [selectedItem]="true"
  [verticalTabBarData]="[
    {
      id: 'filter_filled',
      icon: 'filter_filled',
      hasSeparator: true,
      rightSideTemplate: rightSide,
    },
  ]"
  [isLoading]="false"
  [panelOpen]="isPanelOpen"
  (open)="onPanelStateChange(true)"
  (close)="onPanelStateChange(false)"
>
  <ng-template #rightSide>
    <div side="right" class="action-plan-list__right-side" *transloco="let t">
      <div class="action-plan-list__search-bar-wrapper">
        <xi-search-box
          placeholder="{{ t('action-plan-list-component.placeholder') }}"
          [stretch]="true"
          [outline]="'text'"
        ></xi-search-box>
      </div>

      <div class="action-plan-list__container">
        <div class="action-plan-list__action-plan-table-wrapper">
          <app-action-plan-table
            mode="view"
            (details)="onNavigateDetails($event, false)"
            (edit)="onNavigateDetails($event, true)"
          ></app-action-plan-table>
        </div>
      </div>
    </div>
  </ng-template>
</app-lex-xi-side-panel>
